/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillDetailVo } from './BillDetailVo';
import {
    BillDetailVoFromJSON,
    BillDetailVoFromJSONTyped,
    BillDetailVoToJSON,
    BillDetailVoToJSONTyped,
} from './BillDetailVo';

/**
 * 
 * @export
 * @interface ResponseListBillDetailVo
 */
export interface ResponseListBillDetailVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListBillDetailVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListBillDetailVo
     */
    message?: string;
    /**
     * 
     * @type {Array<BillDetailVo>}
     * @memberof ResponseListBillDetailVo
     */
    data?: Array<BillDetailVo>;
}

/**
 * Check if a given object implements the ResponseListBillDetailVo interface.
 */
export function instanceOfResponseListBillDetailVo(value: object): value is ResponseListBillDetailVo {
    return true;
}

export function ResponseListBillDetailVoFromJSON(json: any): ResponseListBillDetailVo {
    return ResponseListBillDetailVoFromJSONTyped(json, false);
}

export function ResponseListBillDetailVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListBillDetailVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(BillDetailVoFromJSON)),
    };
}

export function ResponseListBillDetailVoToJSON(json: any): ResponseListBillDetailVo {
    return ResponseListBillDetailVoToJSONTyped(json, false);
}

export function ResponseListBillDetailVoToJSONTyped(value?: ResponseListBillDetailVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(BillDetailVoToJSON)),
    };
}

